/**
 * Location
 * 
 * @Author: Focci
 * @Date: 2023-08-07 10:16:09
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 10:16:09
 */

'use client'

import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import useApp from '@hook/useApp'
import { useCallback } from 'react'
import { Waypoint } from 'react-waypoint'
import { useTranslations } from 'next-intl'
import PropertyItemScoff from '../PropertyItemScoff'

export default function Location({
  house = {}
}) {
  const ts = useTranslations('search')
  const { isMobile } = useApp()
  const { Wedget: LocationMap, getWedget } = useLazyComponent()
  
  const mapboxDefaultValue = {
    longitude: house.lng,
    latitude: house.lat,
    zoom: 18,
    // scrollZoom: false
  }

  const handleEnter = useCallback(async () => {
    const wedget = isMobile 
      ? () => import('./SimpleLocation') 
      : () => import('./LocationMap') 
    
    getWedget(wedget)
  }, [getWedget, isMobile])

  return (
    <PropertyItemScoff 
      title={ts('locations')}
      moduleName={ts('locations')}
      id="module-locations"
    >
      <Waypoint onEnter={handleEnter}>
        <div className="flex flex-col border bg-cf0 h-40 md:h-[25rem] relative">
          <LocationMap
            type={house.type}
            house={house}
            houseId={house.houseId}
            propertyId={house.propertyId}
            defaultValue={mapboxDefaultValue}
          />
        </div>
      </Waypoint>
    </PropertyItemScoff>
  )
}

Location.propTypes = {
  house: PropTypes.object,
}
